// src/api/auth.js
import axios from 'axios'

// 1) Create and export the axios instance
export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
})

// 2) (Optional) attach interceptors here too, if you like
apiClient.interceptors.request.use(cfg => {
  const token = localStorage.getItem('auth_token')
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})
apiClient.interceptors.response.use(
  resp => resp,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('auth_token')
      window.location.href = '/login'
    }
    return Promise.reject(err)
  }
)

// 3) Export login & getProfile as plain post/get so your store can do:
//    const { data } = await apiLogin(payload)
export function login(credentials) {
  return apiClient.post('/neue/admin/auth/login', credentials)
}

export function getProfile() {
  return apiClient.get('/neue/admin/auth/profile')
}
